import * as React from 'react';
import * as TypeStyle from 'typestyle';
import { ToolbarColorTheme, useToolbarColorThemeContext } from '../PublicTypes';
import { GenericToolbarItem } from '../types/GenericToolbarItem';

export const SeparatorItem: GenericToolbarItem = { isSeparator: true } as GenericToolbarItem;

export function Separator(): React.ReactElement {
  const colorTheme: ToolbarColorTheme = useToolbarColorThemeContext();
  const styleClassName = React.useMemo(
    () =>
      TypeStyle.style({
        borderLeft: `1px solid ${colorTheme.ButtonContentDisabled}`,
        height: '50%',
        marginLeft: 16,
        marginRight: 16,
        position: 'relative',
        top: '25%',
      }),
    [colorTheme.ButtonContentDisabled]
  );

  return <div className={styleClassName} role="separator" />;
}
